import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var Sketch;
var GraphicsLayer;
var SketchToolComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SketchToolComponent, _super);
    function SketchToolComponent(_vcr) {
        var _this = _super.call(this, _vcr) || this;
        _this.deleteGraphicsWhenDeactivated = true;
        _this.hideGraphicsLayerWhenDeactivated = true;
        _this.oncomplete = new EventEmitter();
        _this._creationMode = 'update';
        _this._defaultCreateOptions = { mode: 'click' };
        _this._defaultUpdateOptions = { tool: 'transform' };
        _this.activate = function (toolType, mode) {
            if (mode === void 0) { mode = null; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(!this.sketch || this.sketch.destroyed)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.load(toolType, mode)];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            this.activateTool(toolType, mode);
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.deactivate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.sketch) {
                    this.sketch.cancel();
                }
                if (this.graphicsLayer) {
                    if (this.deleteGraphicsWhenDeactivated) {
                        this.graphicsLayer.removeAll();
                    }
                    if (this.hideGraphicsLayerWhenDeactivated) {
                        this.graphicsLayer.visible = false;
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.destroy = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.deactivate();
                if (this.sketch && !this.sketch.destroyed) {
                    this.sketch.destroy();
                }
                if (this.graphicsLayer) {
                    this.graphicsLayer.removeAll();
                    this.mapView.map.remove(this.graphicsLayer);
                }
                return [2 /*return*/];
            });
        }); };
        _this.registerEvent('oncomplete', _this.oncomplete);
        return _this;
    }
    SketchToolComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.GraphicsLayer, ESRI.Sketch])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), GraphicsLayer = _a[0], Sketch = _a[1];
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SketchToolComponent.prototype, "creationMode", {
        get: function () {
            return this._creationMode;
        },
        set: function (value) {
            this._creationMode = value;
            if (this.sketch) {
                this.sketch.creationMode = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SketchToolComponent.prototype, "defaultCreateOptions", {
        get: function () {
            return this._defaultCreateOptions;
        },
        set: function (value) {
            this._defaultCreateOptions = value;
            if (this.sketch) {
                this.sketch.defaultCreateOptions = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SketchToolComponent.prototype, "defaultUpdateOptions", {
        get: function () {
            return this._defaultUpdateOptions;
        },
        set: function (value) {
            this._defaultUpdateOptions = value;
            if (this.sketch) {
                this.sketch.defaultUpdateOptions = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SketchToolComponent.prototype, "graphics", {
        get: function () {
            if (this.graphicsLayer) {
                return this.graphicsLayer.graphics.toArray();
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SketchToolComponent.prototype, "geometries", {
        get: function () {
            if (this.graphics) {
                return this.graphics.map(function (x) { return x.geometry; });
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SketchToolComponent.prototype.load = function (toolType, mode) {
        if (mode === void 0) { mode = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sketchContainer;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.addGraphicsLayerToMapIfNotPresent();
                if (!this.containerElement) {
                    this.containerElement = this.hostElement;
                }
                this.containerElement.innerHTML = '';
                sketchContainer = document.createElement('div');
                this.containerElement.appendChild(sketchContainer);
                sketchContainer.style.display = 'none';
                this.graphicsLayer.when(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.sketch = new Sketch({
                                    container: sketchContainer,
                                    layer: this.graphicsLayer,
                                    view: this.mapView,
                                    creationMode: this._creationMode,
                                    defaultCreateOptions: this._defaultCreateOptions,
                                    defaultUpdateOptions: this._defaultUpdateOptions
                                });
                                return [4 /*yield*/, this.activateTool(toolType, mode)];
                            case 1:
                                _a.sent();
                                this.sketch.on('create', function (event) {
                                    _this.processSketchEvent(event);
                                });
                                this.sketch.on('update', function (event) {
                                    _this.processSketchEvent(event);
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    SketchToolComponent.prototype.activateTool = function (toolType, mode) {
        if (mode === void 0) { mode = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var esriModeDefaults;
            return tslib_1.__generator(this, function (_a) {
                esriModeDefaults = {
                    point: null,
                    polyline: 'hybrid',
                    polygon: 'hybrid',
                    rectangle: 'freehand',
                    circle: 'freehand'
                };
                this.addGraphicsLayerToMapIfNotPresent();
                if (!this.sketch.layer) {
                    this.sketch.layer = this.graphicsLayer;
                }
                this.sketch.create(toolType, { mode: mode ? mode : esriModeDefaults[toolType] });
                return [2 /*return*/];
            });
        });
    };
    SketchToolComponent.prototype.addGraphicsLayerToMapIfNotPresent = function () {
        var _this = this;
        if (!this.graphicsLayer) {
            this.graphicsLayer = new GraphicsLayer({ title: 'Sketch Tool', hideInLegend: true });
        }
        if (!this.mapView.map.allLayers.some(function (x) { return x === _this.graphicsLayer; })) {
            this.mapView.map.add(this.graphicsLayer);
        }
        this.graphicsLayer.visible = true;
    };
    SketchToolComponent.prototype.processSketchEvent = function (event) {
        if (event.state === 'complete') {
            if (event.graphic) {
                this.graphicsLayer.add(event.graphic);
            }
            this.oncomplete.emit(true);
        }
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], SketchToolComponent.prototype, "deleteGraphicsWhenDeactivated", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], SketchToolComponent.prototype, "hideGraphicsLayerWhenDeactivated", void 0);
    return SketchToolComponent;
}(BaseComponent));
export { SketchToolComponent };
